import { jsx } from "panel";
export function template() {
  return /* @__PURE__ */ jsx("div", { sel: ".auth-footer", "data-sentry-component": "template", "data-sentry-source-file": "template.tsx" }, this.attr("show-footer-links") && /* @__PURE__ */ jsx("div", { sel: ".auth-footer-links" }, /* @__PURE__ */ jsx("a", { sel: ".auth-footer-link", attrs: {
    href: "/legal/terms-of-use/",
    target: "_blank"
  } }, "Terms and Conditions"), /* @__PURE__ */ jsx("a", { sel: ".auth-footer-link", attrs: {
    href: "/legal/privacy-policy/",
    target: "_blank"
  } }, "Privacy Policy")));
}
